module.exports = __webpack_public_path__ + "static/media/8.00b3c2b4.png";